import { CANVAS_EXPORT_MULTIPLIER, CANVAS_EXPORT_FORMAT } from '../../constants/treatment';

export const exportCanvasToDataURL = canvas => {
    if (!canvas) return '';
    return canvas.toDataURL({
        multiplier: CANVAS_EXPORT_MULTIPLIER,
        format: CANVAS_EXPORT_FORMAT
    });
};

const loadImage = url => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => {
            const retry = new Image();
            retry.crossOrigin = 'anonymous';
            retry.onload = () => resolve(retry);
            retry.onerror = reject;
            retry.src = url + (url.includes('?') ? '&' : '?') + '_cb=' + Date.now();
        };
        img.src = url;
    });
};

export const exportCanvasAtOriginalQuality = async (canvas, originalImageOrUrl) => {
    if (!canvas || !originalImageOrUrl) return exportCanvasToDataURL(canvas);

    try {
        const originalImg =
            originalImageOrUrl instanceof HTMLImageElement ? originalImageOrUrl : await loadImage(originalImageOrUrl);

        const offscreenCanvas = document.createElement('canvas');
        offscreenCanvas.width = originalImg.naturalWidth;
        offscreenCanvas.height = originalImg.naturalHeight;
        const ctx = offscreenCanvas.getContext('2d');

        ctx.drawImage(originalImg, 0, 0);

        const currentZoom = canvas.getZoom();
        const baseWidth = canvas.getWidth() / currentZoom;
        const baseHeight = canvas.getHeight() / currentZoom;

        const scaleX = originalImg.naturalWidth / baseWidth;
        const scaleY = originalImg.naturalHeight / baseHeight;
        const scale = Math.min(scaleX, scaleY);

        const drawingsDataUrl = canvas.toDataURL({
            format: 'png',
            multiplier: scale / currentZoom
        });

        const drawingsImg = await loadImage(drawingsDataUrl);
        ctx.drawImage(drawingsImg, 0, 0, originalImg.naturalWidth, originalImg.naturalHeight);

        return offscreenCanvas.toDataURL('image/jpeg', 0.92);
    } catch (error) {
        console.error('Export at original quality failed:', error);
        return exportCanvasToDataURL(canvas);
    }
};
